import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Receipt } from 'lucide-react';
import { formatCurrency } from '@/lib/formatUtils';
import type { TaxLiabilities } from '@/hooks/useDashboardInsights';

interface TaxLiabilitiesCardProps {
  taxLiabilities: TaxLiabilities;
}

export const TaxLiabilitiesCard: React.FC<TaxLiabilitiesCardProps> = ({
  taxLiabilities,
}) => {
  return (
    <Card className="bg-card">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <Receipt className="h-4 w-4 text-muted-foreground" />
          <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Tax Liabilities
          </span>
        </div>

        <div className="space-y-4">
          <div>
            <p className="text-sm text-muted-foreground mb-1">
              Sales Tax
              {taxLiabilities.stateCode && taxLiabilities.salesTaxRatePercent > 0 && (
                <span className="ml-1">
                  ({taxLiabilities.salesTaxRatePercent.toFixed(2)}% for {taxLiabilities.stateCode})
                </span>
              )}
            </p>
            <p className="text-xl font-semibold font-mono">
              {formatCurrency(taxLiabilities.salesTaxLiability)}
            </p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">
              Payroll Tax (15.3% of W2 payroll)
            </p>
            <p className="text-xl font-semibold font-mono">
              {formatCurrency(taxLiabilities.payrollTaxLiability)}
            </p>
          </div>
        </div>

        <p className="text-xs text-muted-foreground mt-4">
          These amounts are deducted from Safe to Spend.
        </p>
      </CardContent>
    </Card>
  );
};
